import styled from 'styled-components';

interface ContainerProps {
  $open?: boolean;
}

export const Container = styled('div')<ContainerProps>`
  border-bottom: 1px solid #cccccc;
  padding-bottom: ${({ $open }) => ($open ? '16px' : '0')};

  &:last-child {
    border-bottom: none;
  }
`;

export const Header = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 0;
`;

export const Title = styled('div')`
  font-size: 19px;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;
`;

export const Radio = styled('input')`
  width: 20px;
  height: 20px;
  accent-color: #262ba6;
`;
